module.exports = __webpack_public_path__ + "assets/img/4_45_big.f68f968b.jpg";